export const siteConfig = {
  name: "风间由美官方粉丝站",
  title: "风间由美——官方粉丝落地页",
  description: "风间由美，日本知名女演员与艺人，本页汇聚其最新动态、作品履历、演艺生涯精华及粉丝专属内容，带你全面了解风间由美的魅力与艺术成就。",
  keywords: "风间由美,风间由美作品,风间由美演艺经历,风间由美最新动态,风间由美粉丝站,风间由美个人资料",
  url: "https://kazama-yumi-fans.com",
  author: "风间由美官方粉丝站",
  language: "zh-CN",
  ogImage: "https://readdy.ai/api/search-image?query=Elegant%20Japanese%20actress%20artistic%20portrait%20with%20soft%20warm%20lighting%20and%20sophisticated%20atmosphere%2C%20minimalist%20composition%2C%20beautiful%20feminine%20silhouette%20against%20warm%20background&width=1200&height=630&seq=og-image-01&orientation=landscape",
};

export const categories = [
  { id: "all", name: "全部作品", slug: "all", description: "风间由美全部演艺作品汇总" },
  { id: "movie", name: "电影作品", slug: "movie", description: "风间由美参演的电影作品" },
  { id: "tv", name: "电视剧集", slug: "tv", description: "风间由美参演的电视剧作品" },
  { id: "stage", name: "舞台剧", slug: "stage", description: "风间由美出演的舞台剧作品" },
  { id: "variety", name: "综艺节目", slug: "variety", description: "风间由美参与的综艺节目" },
];

export const newsCategories = [
  { id: "all", name: "全部动态", slug: "all" },
  { id: "release", name: "新作发布", slug: "release" },
  { id: "event", name: "活动出席", slug: "event" },
  { id: "interview", name: "访谈专访", slug: "interview" },
  { id: "fan", name: "粉丝活动", slug: "fan" },
];